import { Avatar } from '@creditornot/cb-avatar';
import { cbSemanticCssVars, WoltLogo } from '@creditornot/cb-ingredients';
import { LegacyPopover } from '@creditornot/cb-popover';
import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';

import { useUserProfile } from 'modules/experience/hooks/useUserProfile';

import { UserDropDown } from '../UserDropDown/UserDropDown';

const HeaderContainer = styled.div`
  position: fixed;
  display: flex;
  height: 48px;
  min-height: 48px;
  padding: 0 24px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
  background-color: ${cbSemanticCssVars.surfaceMain};
  width: 100%;
  max-width: 100%;
  z-index: 1000;
  align-items: center;
  justify-content: space-between;

  @media (width <= 540px) {
    padding: 0 18px;
  }
`;

const StyledWoltLogo = styled(WoltLogo)`
  height: 16px;
  fill: ${cbSemanticCssVars.textPrimary};
`;

const StyledAvatar = styled(Avatar)`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const Header = () => {
  const { profilePicUrl, initials } = useUserProfile();
  const [show, setShow] = useState(false);

  return (
    <HeaderContainer>
      <StyledWoltLogo />
      <LegacyPopover
        content={<UserDropDown hideDropDown={() => setShow(false)} />}
        onClickOutside={() => setShow(false)}
        show={show}
        renderArrow={false}
        disableContentPadding
      >
        <StyledAvatar size="small" imgSrc={profilePicUrl} initials={initials} onClick={() => setShow(!show)} />
      </LegacyPopover>
    </HeaderContainer>
  );
};
